import { useMutation, useQueryClient } from '@tanstack/react-query';
import doRegisterSkuViewById from '@/api/doRegisterSkuViewById';
import doRegisterSkuViewBySlug from '@/api/doRegisterSkuViewBySlug';
import { useRef } from 'react';

export const useTrackSkuView = (skuId: string) => {
  const skuIdRef = useRef<string | number | null>(null);
  const queryClient = useQueryClient();

  const trackSkuViewById = useMutation({
    mutationKey: ['track-sku-view', 'id', skuId],
    mutationFn: () => {
      if (!skuId) {
        throw new Error('SKU ID is required');
      }
      return doRegisterSkuViewById(skuId);
    },
    onSuccess: () => {
      if (skuIdRef.current) {
        queryClient.invalidateQueries({ queryKey: ['skuViewStats', skuIdRef.current] });
      }
    },
  });

  const trackSkuViewBySlug = useMutation({
    mutationKey: ['track-sku-view', 'slug', skuId],
    mutationFn: () => {
      if (!skuId) {
        throw new Error('SKU ID is required');
      }
      return doRegisterSkuViewBySlug(skuId);
    },
  });

  return { trackSkuViewById, trackSkuViewBySlug };
};
